// extracted by mini-css-extract-plugin
export default {"appStore":"appStore_WQsfc","picture":"picture_NwhuN"};